import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { connect } from 'react-redux';
import {
  getWangyuCouponList,
  // getDouyinCouponList,
  getManualCouponList,
} from '@/redux/actions/guest';
import { GuestInitialStateProps, IguestInfo } from '@/redux/reducers/guest';
import { ItabItem, renderIntlLabel } from '@/utils';
import { CouponTabStatus } from '@/config';
import WangyuCouponLeftTabItem from '../WangyuCouponLeftTabItem';
// import DouyinCouponLeftTabItem from '../DouyinCouponLeftTabItem';
import ManualCouponLeftTabItem from '../ManualCouponLeftTabItem';
import styles from './index.module.scss';

const { TabPane } = Tabs;

const mapDispatchToProps = {
  getWangyuCouponListFn: getWangyuCouponList,
  // getDouyinCouponListFn: getDouyinCouponList,
  getManualCouponListFn: getManualCouponList,
};
type MapDispatchProps = Partial<typeof mapDispatchToProps>;
interface CouponLeftTabProps extends Partial<GuestInitialStateProps> {
  guestInfo?: Partial<IguestInfo>;
}

const CouponLeftTab: React.FC<CouponLeftTabProps & MapDispatchProps> = ({
  guestInfo,
  basicCardInfo,
  wangyuCouponList,
  // douyinCouponList,
  manualCouponList,
  allWangyuCouponListLoading,
  // allDouyinCouponListLoading,
  allManualCouponListLoading,
  getWangyuCouponListFn,
  // getDouyinCouponListFn,
  getManualCouponListFn,
}) => {
  const [selectedKey, setSelectedKey] = useState<string>();
  const [couponTabKey, setCouponTabKey] = useState<string>(CouponTabStatus.CanUse);

  const handleTabChange = (key) => {
    setSelectedKey(key);
  };

  const handleGiveCouponClose = () => {
    if (!guestInfo?.wyuid) {
      return;
    }
    getWangyuCouponListFn({ wyuid: guestInfo.wyuid, couponStatus: couponTabKey });
  };

  const onCouponTabChange = (key) => {
    setCouponTabKey(key);
    getWangyuCouponListFn({ wyuid: guestInfo.wyuid, couponStatus: key });
  };

  const initWangyuList = (sortType) => {
    if (guestInfo.wyuid) {
      getWangyuCouponListFn({ sortType, wyuid: guestInfo.wyuid, couponStatus: couponTabKey });
    }
  };

  const onSave = (sortType) => {
    initWangyuList(sortType);
  };

  const onSortChange = (sortType) => {
    initWangyuList(sortType);
  };

  // const couponCanUseList = wangyuCouponList?.find((item) => CouponTabStatus.CanUse === item.status)
  //   ?.couponList;
  const unusedList = manualCouponList?.find((item) => item.status === 0)?.xzCouponList;
  const tabList: Array<ItabItem> = [
    {
      key: 'wangyu',
      tab: renderIntlLabel('guest_coupon_tab_wangyu_coupon', {
        number: wangyuCouponList?.length || 0,
      }),
      component: (
        <WangyuCouponLeftTabItem
          guestInfo={guestInfo}
          basicCardInfo={basicCardInfo}
          dataSource={wangyuCouponList}
          loading={allWangyuCouponListLoading}
          onSave={onSave}
          onSortChange={onSortChange}
          onGiveCouponClose={handleGiveCouponClose}
          onCouponTabChange={onCouponTabChange}
        />
      ),
    },
    // {
    //   key: 'douyin',
    //   tab: '抖音券',
    //   component: (
    //     <DouyinCouponLeftTabItem
    //       dataSource={douyinCouponList}
    //       loading={allDouyinCouponListLoading}
    //     />
    //   ),
    // },
    {
      key: 'xuanzhu',
      tab: renderIntlLabel('guest_coupon_tab_manual_coupon', { number: unusedList?.length || 0 }),
      component: (
        <ManualCouponLeftTabItem
          dataSource={manualCouponList}
          loading={allManualCouponListLoading}
        />
      ),
    },
  ];

  useEffect(() => {
    if (!guestInfo?.wyuid) {
      return;
    }
    if (!selectedKey || selectedKey === 'wangyu') {
      getWangyuCouponListFn({ wyuid: guestInfo.wyuid, couponStatus: CouponTabStatus.CanUse });
    }
    if (!selectedKey || selectedKey === 'xuanzhu') {
      getManualCouponListFn({ wyuid: guestInfo.wyuid });
    }
  }, [guestInfo, selectedKey]);

  return (
    <>
      <div className={styles.container}>
        <Tabs
          activeKey={selectedKey}
          onChange={handleTabChange}
          tabPosition="left"
          destroyInactiveTabPane
        >
          {tabList?.map((item) => (
            <TabPane tab={item.tab} key={item.key}>
              {item.component}
            </TabPane>
          ))}
        </Tabs>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.guest,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(CouponLeftTab));
